import React from "react";
import { Link } from "react-router-dom";
import { pageURLs } from "@/constants";
import { LOGIN } from "@/constants/onBoarding";
import "./GuestHeaderActions.scss";

// Sign in and sign up share one entry point: the login modal links on to sign-up.
const GuestHeaderActions = ({ handleAgentOnboardingModal }) => (
  <div className="guest-header-actions">
    <Link className="guest-header-actions__secondary" to={pageURLs.agentDirectory}>
      Agents
    </Link>
    <button
      type="button"
      className="guest-header-actions__start"
      onClick={() => handleAgentOnboardingModal?.({ showPopup: true, userAction: LOGIN })}
    >
      Sign in / Sign up
    </button>
  </div>
);

export default GuestHeaderActions;
